(function () {
  if (window.__ztkNewsletterKlaviyoLoaded) return;
  window.__ztkNewsletterKlaviyoLoaded = true;

  var KLAVIYO_COMPANY_ID = 'XwYDBk';
  var KLAVIYO_LIST_ID = 'WYBcRF';

  function suscribirNewsletter(email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email },
              },
            },
            custom_source: 'Newsletter web ZTK Farm',
          },
          relationships: {
            list: {
              data: { type: 'list', id: KLAVIYO_LIST_ID },
            },
          },
        },
      }),
    });
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-ztk-newsletter-form]')) return;
    event.preventDefault();

    var wrapper = form.closest('[data-ztk-newsletter-wrapper]') || form.parentElement;
    var input = form.querySelector('input[type="email"]');
    var errorEl = wrapper.querySelector('[data-ztk-newsletter-error]');
    var successEl = wrapper.querySelector('[data-ztk-newsletter-success]');
    var email = input ? input.value.trim() : '';

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    if (!email) return;

    var submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    suscribirNewsletter(email)
      .then(function (response) {
        if (response.status === 202) {
          form.hidden = true;
          if (successEl) successEl.hidden = false;
        } else {
          throw new Error('Klaviyo subscription failed with status ' + response.status);
        }
      })
      .catch(function () {
        if (errorEl) {
          errorEl.textContent = 'No se ha podido completar la suscripción. Inténtalo de nuevo.';
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        if (submitButton) submitButton.disabled = false;
      });
  }

  document.addEventListener('submit', handleSubmit);
})();
